var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAngleLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  "aria-hidden": "true",
  "data-prefix": "fal",
  "data-icon": "angle-left",
  className: "angle-left_svg__svg-inline--fa angle-left_svg__fa-angle-left angle-left_svg__fa-w-6",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 192 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m25.1 247.5 117.8-116c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L64.7 256l102.2 100.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L25 264.5c-4.6-4.7-4.6-12.3.1-17z"
})));
export { SvgAngleLeft as ReactComponent };
export default __webpack_public_path__ + "static/media/angle-left.05a4a2df.svg";